export default "https://cdn-static.gokick.com/assets/89c12df47656b56f32e50d5631dab02a560652ab/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";